var _path, _path2, _path3, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSOne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 49,
    viewBox: "0 0 57 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 28C38.5228 28 43 23.5228 43 18C43 12.4772 38.5228 8 33 8C27.4772 8 23 12.4772 23 18C23 23.5228 27.4772 28 33 28Z",
    fill: "#ABDCFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0001 22.72V42M40.0801 25.8C41.9548 23.9247 43.0079 21.3816 43.0079 18.73C43.0079 16.0784 41.9548 13.5353 40.0801 11.66M25.9201 11.66C24.0453 13.5353 22.9922 16.0784 22.9922 18.73C22.9922 21.3816 24.0453 23.9247 25.9201 25.8M35.0001 18.72C35.0001 19.1156 34.8828 19.5022 34.663 19.8311C34.4432 20.16 34.1309 20.4164 33.7654 20.5678C33.4 20.7191 32.9978 20.7587 32.6099 20.6816C32.2219 20.6044 31.8655 20.4139 31.5858 20.1342C31.3061 19.8545 31.1157 19.4981 31.0385 19.1102C30.9613 18.7222 31.0009 18.3201 31.1523 17.9546C31.3037 17.5892 31.56 17.2768 31.8889 17.0571C32.2178 16.8373 32.6045 16.72 33.0001 16.72C33.5305 16.72 34.0392 16.9307 34.4143 17.3058C34.7893 17.6809 35.0001 18.1896 35.0001 18.72Z",
    stroke: "#215FF2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.72 6C47.3921 7.67153 48.7185 9.6561 49.6234 11.8403C50.5284 14.0246 50.9942 16.3657 50.9942 18.73C50.9942 21.0943 50.5284 23.4354 49.6234 25.6197C48.7185 27.8039 47.3921 29.7885 45.72 31.46M20.28 6C18.6079 7.67153 17.2815 9.6561 16.3766 11.8403C15.4716 14.0246 15.0059 16.3657 15.0059 18.73C15.0059 21.0943 15.4716 23.4354 16.3766 25.6197C17.2815 27.8039 18.6079 29.7885 20.28 31.46",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 27,
    r: 22,
    fill: "#215FF2",
    fillOpacity: 0.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSOne);
export default __webpack_public_path__ + "static/media/s-one.1a1d8adf7d6f3c783c553dc37e64cf16.svg";
export { ForwardRef as ReactComponent };